import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import { COLOR_MENU } from "shared/theme/colors";

export const StyledMenuBarContainer = styled(Box, {
  shouldForwardProp: (props) => props !== "expanded" && props !== "isHovered",
})<{ expanded?: boolean; isHovered?: boolean }>`
  width: ${({ expanded }) => (expanded ? "320px" : "135px")};
  flex: 0 0 auto;
  flex-shrink: 0;
  transition: width 0.2s ease-in-out;
  background-color: ${COLOR_MENU};
  position: ${({ isHovered }) => (isHovered ? "absolute" : "fixed")};
  left: 0;
  top: 0;
  z-index: ${({ isHovered }) => (isHovered ? 1000 : 1)};
`;

export const StyledMenuBar = styled(Box, {
  shouldForwardProp: (props) => props !== "bgColor" && props !== "expanded",
})<{ bgColor?: string; expanded?: boolean }>`
  width: ${({ expanded }) => (expanded ? "308px" : "auto")};
  flex: 1 0 auto;
  background-color: ${COLOR_MENU};
  height: 100%;
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
`;

export const StyledContent = styled(Box)`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0 1.5rem;
  overflow: auto;

  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const StyledChipsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  margin: 1.5rem 1.5rem 0;
`;
